module.exports = __webpack_public_path__ + "img/害羞.13cb59b7.gif";